import { useMemo } from "react";
export const useTranslate = (translations) => {
    const t = useMemo(() => {
        const memoizedTranslations = new Map();
        return (label, params = undefined) => {
            // Keyed on the parameters too: a label memoized alone kept its first values forever
            // ("Tags ({count})" never changed after the first render).
            const key = params === undefined ? label : label + "|" + JSON.stringify(params);
            if (!memoizedTranslations.has(key)) {
                memoizedTranslations.set(key, translations.get(label, params));
            }
            return memoizedTranslations.get(key);
        };
    }, [translations]);
    return t;
};
